import { 
    Component, 
    OnInit, 
    Input, 
    EventEmitter, 
    Output, 
    ViewChild, 
    ViewContainerRef, 
    ComponentFactoryResolver,
    ComponentRef 
} from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { AvalesService } from '../../../services/avales.service';
import { FormularioAvalComponent } from '../formulario-aval/formulario-aval.component';

@Component({
  selector: 'listado-avales',
  templateUrl: './listado-avales.component.html'
})
export class ListadoAvalesComponent implements OnInit {
    //@ViewChild('formularioAval') formularioAval: FormularioAvalComponent;
    @ViewChild('listadoAvales', { read: ViewContainerRef }) listadoAvales: ViewContainerRef;

    @Input() public idCreditos : number = null;
    @Input() public isCompleted : boolean = false;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    
    public aval: any = {};
    public errors: any = {};
    public isLoading: boolean = true;
    private isInitialized: boolean = false;

    constructor(
      private componentFactoryResolver: ComponentFactoryResolver,
      private avalesService : AvalesService,
      private helperService: HelpersService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
        if(!this.isInitialized){
            this.getAvales(this.idCreditos);
            this.isInitialized = true;
        }
    }

    public agregarAval(){
        this.renderAvalForm();
    }

    public renderAvalForm(aval: object = null){
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormularioAvalComponent);
        const componentRef: ComponentRef<FormularioAvalComponent> = this.listadoAvales.createComponent(componentFactory);
        componentRef.instance.isEditable = this.isEditable;
        componentRef.instance.idCreditos = this.idCreditos;
        
        //Si es un aval ya existente, se asigna los datos de su modelo al formulario
        if(aval){
            componentRef.instance.aval = aval;
        }

        let baseComponent = this;
        componentRef.instance.onAvalDeleted.subscribe(() => {
            componentRef.destroy();
            baseComponent.onDataUpdated.emit();
        });

        componentRef.instance.onDataUpdated.subscribe(() => {
            baseComponent.onDataUpdated.emit();
        })
    }

    private getAvales(idCreditos : number){
        //Show ajax loader
        this.isLoading = true;
        //TODO: Manejar cuando el id no retorna un aval valido
        this.avalesService.get(idCreditos).subscribe(
          (response)=>
          {
            const avales = response.json().content;
            if(avales.length > 0){
                this.showAvales(avales);
            }            
            //Hide ajax loader
            this.isLoading = false;
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }

    private showAvales(avales: any[]){
        for(let i=0; i<avales.length; i++){
            let aval = avales[i];
            this.renderAvalForm(aval);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/creditos/components/listado-avales/listado-avales.component.ts